<template>
  <div class="accordion" :id="accordionOuterId">
    <div class="accordion-item accordion-layout nested-nav">
      <div
        ref="navAccordion"
        class="d-flex align-items-center accordion-layout-inner mt-1"
        :class="[justifyClass, { active: isNavItemActive }]"
        @click="toggle"
        data-bs-toggle="collapse"
        :data-bs-target="'#' + accordionInnerId"
        aria-expanded="false"
        :aria-controls="accordionInnerId"
      >
        <div>
          <NavElement
            :name="name"
            :href="href"
            :is-expanded="isExpanded"
            hoverand-active-bg="none"
          />
        </div>
        <div class="me-3" v-show="isExpanded">
          <MsButton
            data-bs-toggle="collapse"
            :data-bs-target="'#' + accordionInnerId"
            aria-expanded="false"
            :aria-controls="accordionInnerId"
            :button-size="ButtonSize.NoPadding"
          >
            <img
              :src="arrow"
              :class="{ rotated: isNavAccordionOpen }"
              class="icon ms-rotate-icon"
            />
          </MsButton>
        </div>
      </div>

      <div
        ref="navAccordionData"
        :id="accordionInnerId"
        class="accordion-collapse collapse"
        :data-bs-parent="'#' + accordionOuterId"
      >
        <NestedNavElement
          name="Profile"
          :href="href + '/profile'"
          :is-expanded="isExpanded"
          @is-active="setActive"
        ></NestedNavElement>

        <NestedNavElement
          name="Organisations"
          :href="href + '/organisations'"
          :is-expanded="isExpanded"
          @is-active="setActive"
        ></NestedNavElement>

        <NestedNavElement
          name="Projects"
          :href="href + '/projects'"
          :is-expanded="isExpanded"
          @is-active="setActive"
        ></NestedNavElement>

        <NestedNavElement
          name="Alarms"
          :href="href + '/alarm/configurations'"
          :is-expanded="isExpanded"
          @is-active="setActive"
        ></NestedNavElement>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, computed, watch, defineEmits } from 'vue'
import NavElement from './NavElement.vue'
import arrow from '@/assets/svg/arrow.svg'
import MsButton from '@/components/general/buttons/MsButton.vue'
import { ButtonSize } from '@/utilities/enums'
import NestedNavElement from './NestedNavElement.vue'

var props = defineProps({
  name: String,
  href: String,
  isExpanded: Boolean
})

const emit = defineEmits(['expand'])

const navAccordion = ref()
const navAccordionData = ref()

const accordionOuterId = ref('nav-item-outer-' + props.name)

const accordionInnerId = ref('nav-item-inner-' + props.name)

const isNavAccordionOpen = ref(false)
const isNavItemActive = ref(false)

const toggle = () => {
  if (!props.isExpanded && !isNavAccordionOpen.value) {
    emit('expand')
  }
  isNavAccordionOpen.value = !isNavAccordionOpen.value
}

const justifyClass = computed(
  () => `${props.isExpanded ? 'justify-content-between' : 'justify-content-center'}`
)

const setActive = (isActive: boolean) => {
  isNavItemActive.value = isActive
}

watch(
  () => props.isExpanded,
  (newVal) => {
    if (!newVal && isNavAccordionOpen.value) {
      navAccordion.value.click()
    }
  }
)
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.nested-nav {
  border: none;
}

.accordion-layout-inner {
  height: 42px;
  cursor: pointer;
}

.accordion-layout-inner:hover,
.accordion-layout-inner.active {
  background-color: color.$color-lighter-grey !important;
  border-radius: 4px;
}
</style>
